import React from 'react';
import classNames from 'classnames';

import css from './IconBalcony.module.css';

/**
 * IconBalcony icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconBalcony = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
<svg className={classes} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.25 11.5V10H9.75V11.5H8.25ZM14.25 11.5V10H15.75V11.5H14.25ZM3 22V14H4V10C4 8.9 4.20834 7.8625 4.625 6.8875C5.04165 5.9125 5.6125 5.0625 6.3375 4.3375C7.0625 3.6125 7.9125 3.04166 8.8875 2.625C9.8625 2.20834 10.9 2 12 2C13.1 2 14.1375 2.20834 15.1125 2.625C16.0875 3.04166 16.9375 3.6125 17.6625 4.3375C18.3875 5.0625 18.9584 5.9125 19.375 6.8875C19.7917 7.8625 20 8.9 20 10V14H21V22H3ZM4.5 20.5H7.125V15.5H4.5V20.5ZM8.625 20.5H11.25V15.5H8.625V20.5ZM5.5 14H11.25V3.55C9.6 3.75 8.22915 4.45834 7.1375 5.675C6.04585 6.89165 5.5 8.33335 5.5 10V14ZM12.75 14H18.5V10C18.5 8.33335 17.9541 6.89165 16.8625 5.675C15.7708 4.45834 14.4 3.75 12.75 3.55V14ZM12.75 20.5H15.375V15.5H12.75V20.5ZM16.875 20.5H19.5V15.5H16.875V20.5Z" fill="#262338"/>
</svg>

  );
};

export default IconBalcony;
